module.exports = __webpack_public_path__ + "assets/img/icon.51fa5124.png";